<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="roles"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="角色名称">
            <el-input v-model.trim="filter.roleName" placeholder="请输入角色名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <role-edit ref="roleEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import RoleEdit from "./RoleEdit.vue";
  export default {
    name:"RoleList",
    components: { viewTable, RoleEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(254),
          editAuth: this.$auth(255),
          delAuth: this.$auth(256),
        },
        filter: {
          roleName: "",
        },
        columnsProperty: [
          {
          tooltip: true,
            key: "id",
            width: 80,
            align: "center",
          },
          {
            key: "roleName",
            tooltip: true,
            minWidth: 300,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.roleEdit.open(params.row, true);
                    },
                  },
                },
                params.row.roleName
              );
            },
          },
          {
            key: "note",
            tooltip: true,
            minWidth: 300,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.roleEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "roles", row.id).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
